export default "__VITE_ASSET__DDt9oRl2__"